<template>
  <div v-on="$listeners"
       :style="containerStyle">
    <div v-if="tabsRight" :style="fillerStyle" />
    <div v-for="(tab, index) in tabs" :key="index"
         :class="$style.tab"
         :disabled="tab.disabled"
         :selected="index === selectedTabIndex"
         :style="tabStyle"
         @click.prevent="switchTab(index)">
      {{ tab.label }}
    </div>
    <div v-if="!tabsRight" :style="fillerStyle" />
  </div>
</template>

<script>
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseTab',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'switch-tab',
    },
    props: {
      vmodelValue: { type: Number },
      tabsRight: { type: Boolean, required: false, default: false },
      initSelectedTabIndex: { type: Number, required: false, default: 0 },
      tabs: { type: Array, required: false, default: () => [] },
    },
    data: function () {
      return {
        containerStyle: {
          display: 'flex',
        },
        fillerStyle: {
          flexGrow: 1,
        },
        postfixes: ['', 'hover', 'active', 'selected', 'disabled'],
        selectedTabIndex: 0,
        tabStyle: {},
      };
    },
    created: function () {
      this.selectedTabIndex = this.vmodelValue;

      this.containerStyle = {
        ...this.containerStyle,
        justifyContent: this.tabsRight ? 'flex-start' : 'flex-end',
        ...this.$attrs,
      };

      this.fillerStyle = {
        ...this.fillerStyle,
        ...this.$attrs.fillerStyle,
      };

      const classObject = getPseudoClassesObject(
        this.$attrs.tabStyle, DefaultPseudoClassAttributeNames,
        '--base-tab-tab-', DefaultPseudoClassVariableNames, this.postfixes);
      const attrs = filterObjectByArray(
        this.$attrs.tabStyle, DefaultPseudoClassAttributeNames);

      this.tabStyle = {
        ...this.tabStyle,
        ...attrs,
        ...classObject,
      };
    },
    methods: {
      switchTab: function (tabIndex) {
        if (!this.tabs[tabIndex].disabled) {
          this.selectedTabIndex = tabIndex;
          this.$emit('switch-tab', tabIndex);
        }
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.selectedTabIndex = newVal;
      },
      selectedTabIndex: function (newVal, oldVal) {
        this.$emit('switch-tab', newVal);
      },
    },
  };
</script>

<style lang="stylus" module>
  .tab
    cursor var(--base-tab-tab-cursor)
    background-color var(--base-tab-tab-bg-color)
    color var(--base-tab-tab-color)
    font-faimly var(--base-tab-tab-font-family)
    font-weight var(--base-tab-tab-font-weight)
    font-size var(--base-tab-tab-font-size)
    border var(--base-tab-tab-border)
    border-width var(--base-tab-tab-border-width)
    border-radius var(--base-tab-tab-border-radius)
    scale var(--base-tab-tab-scale)
    &:hover
      cursor var(--base-tab-tab-cursor-hover)
      background-color var(--base-tab-tab-bg-color-hover)
      color var(--base-tab-tab-color-hover)
      font-faimly var(--base-tab-tab-font-family-hover)
      font-weight var(--base-tab-tab-font-weight-hover)
      font-size var(--base-tab-tab-font-size-hover)
      border var(--base-tab-tab-border-hover)
      border-width var(--base-tab-tab-border-width-hover)
      border-radius var(--base-tab-tab-border-radius-hover)
      scale var(--base-tab-tab-scale-hover)
    &:active
      cursor var(--base-tab-tab-cursor-active)
      background-color var(--base-tab-tab-bg-color-active)
      color var(--base-tab-tab-color-active)
      font-faimly var(--base-tab-tab-font-family-active)
      font-weight var(--base-tab-tab-font-weight-active)
      font-size var(--base-tab-tab-font-size-active)
      border var(--base-tab-tab-border-active)
      border-width var(--base-tab-tab-border-width-active)
      border-radius var(--base-tab-tab-border-radius-active)
      scale var(--base-tab-tab-scale-active)
    &[selected]
      cursor var(--base-tab-tab-cursor-selected)
      background-color var(--base-tab-tab-bg-color-selected)
      color var(--base-tab-tab-color-selected)
      font-faimly var(--base-tab-tab-font-family-selected)
      font-weight var(--base-tab-tab-font-weight-selected)
      font-size var(--base-tab-tab-font-size-selected)
      border var(--base-tab-tab-border-selected)
      border-width var(--base-tab-tab-border-width-selected)
      border-radius var(--base-tab-tab-border-radius-selected)
      scale var(--base-tab-tab-scale-selected)
    &[disabled]
      cursor var(--base-tab-tab-cursor-disabled)
      background-color var(--base-tab-tab-bg-color-disabled)
      color var(--base-tab-tab-color-disabled)
      font-faimly var(--base-tab-tab-font-family-disabled)
      font-weight var(--base-tab-tab-font-weight-disabled)
      font-size var(--base-tab-tab-font-size-disabled)
      border var(--base-tab-tab-border-disabled)
      border-width var(--base-tab-tab-border-width-disabled)
      border-radius var(--base-tab-tab-border-radius-disabled)
      scale var(--base-tab-tab-scale-disabled)
</style>
